import request from '@/utils/request'

const prefix = '/django_rest/event-track/'

export default {
  trackCandidateViewJobDetail: (params) => {
    return request.post(`${prefix}candidate/view/job-detail/`, params)
  },
  trackCandidateViewJobList: (params) => {
    return request.post(`${prefix}candidate/view/job-list/`, params)
  },
  trackCandidateShareJobDetail: (params) => {
    return request.post(`${prefix}candidate/share-job/`, params)
  },
  trackCandidateShareJobList: (params) => {
    return request.post(`${prefix}candidate/share-job-list/`, params)
  },
  trackCandidateShareCampaign: (params) => {
    return request.post(`${prefix}candidate/share-campaign/`, params)
  }
}
